import { ListItem, Typography , Link } from "@material-ui/core";
import { NavItemProps } from "components/Navbar/NavItemProps";
import {  Link as RouterLink } from "react-router-dom";
import { useStore } from "store/StoreConfigs";
import NavbarIcon from "./NavbarIcon";
import { navbarStyles } from "./NavbarStyles";


export function NavbarItem(props: NavItemProps) {
    const classes = navbarStyles();
    const { commonStore } = useStore();

    return (
        <Link
            style={{
                textDecoration: "none",
                color: "black",
                display: "flex",
            }}
            component={RouterLink}
            to={props.route}
        >
            <ListItem
                button
                classes={{ selected: classes.selected }}
                className={props.navbarItemStyles}
                onClick={props.onClickFunc}
                selected={props.selectedState}
            >
                <NavbarIcon
                    navbarIconStyles={props.navbarIconStyles}
                    navbarIcon={props.navbarIcon}
                />
                {commonStore.isNavbarOpen && (
                    <Typography className={props.navbarTextStyles}>
                        {props.navbarText}
                    </Typography>
                )}
            </ListItem>
        </Link>
    );
}
